export const ADD_SUPPLIER_FROM_SOCKET = "ADD_SUPPLIER_FROM_SOCKET";
export const GET_SUPPLIERS = "GET_SUPPLIERS";
export const ADD_GHOST_SUPPLIER = "ADD_GHOST_SUPPLIER";
export const RESET_GHOST_SUPPLIER = "RESET_GHOST_SUPPLIER";
export const RESET_SUPPLIER_ERROR = "RESET_SUPPLIER_ERROR";


// WEBPACK FOOTER //
// ./src/components/supplier/actions/types.js